import { getFundAccountList } from '@/api/agentPayment/payment.js';
import { deepCopy } from '@/u-components/utils/assist';
const fundAccountRefer = (ctrl, vm) => {
  const control = Object.assign(
    {},
    {
      title: vm.mlang('fundAccount'),
      page: false,
      bRefer: true,
      bread: false,
      multiple: true,
      clearable: true,
      hideDelete: vm.$route.query.titleType === 'detail' || vm.$route.query.titleType === 'editor',
      controlType: 'Refer',
      refName:'name',
      hideQueryschema: true,
      clearSelect: true,
      passedparams: [{
        conditionType: 'eq',
        name: 'saleOrgId',
        v1: vm.payment.salesOrgId,
        valueType: 'STRING'
      },{
        conditionType: 'eq',
        name: 'settlementOrgId',
        v1: vm.payment.settlementOrgId,
        valueType: 'STRING'
      },{
        conditionType: 'eq',
        name: 'origCurrencyId',
        v1: vm.payment.originalCurrencyVo?.id,
        valueType: 'STRING'
      }, {
        conditionType: 'eq',
        name: 'agentId',
        v1: vm.currentUser.agentId,
        valueType: 'LONG'
      }],
      columns: [
        {
          showCaption: vm.mlang('fundAccountName'),
          isShowIt: true,
          fieldName: 'name',
          width: 200
        },{
          showCaption: vm.mlang('fundAccountCode'),
          isShowIt: true,
          fieldName: 'code',
          width: 200
        },
        {
          showCaption: vm.mlang('accountTypeName'),
          fieldName: 'capitalAccountRuleName',
          width: 200,
          isShowIt: true
        },
        {
          showCaption: vm.mlang('accountTypeCode'),
          fieldName: 'capitalAccountRuleCode',
          width: 200,
          isShowIt: true
        }
      ],
      actions: { queryList: getFundAccountList },
      type: 'long',
      op: 'eq'
    },
    ctrl
  );
  return deepCopy(control);
};
export default fundAccountRefer;
